module.exports = __webpack_public_path__ + "img/yoiko_thum2.66f77b5d.jpg";